import { put, takeEvery, takeLatest } from "redux-saga/effects";

import userProfileService from "../../../services/user";
import {
  getUserProfileDetailsStart,
  getUserProfileDetailsSuccess,
  getUserProfileDetailsFailure,
  updateUserProfileStart,
  updateUserProfileSuccess,
  updateUserProfileFailure,
  getWalletBalanceSuccess,
} from "../../redux/profile/myProfile";
import { connectMetamaskSuccess } from "../../redux/auth/authentication";
import { showSuccessMessage, showErrorMessage } from "../../redux/toast";

function* userProfileWatcher() {
  yield takeEvery(getUserProfileDetailsStart.type, userProfileWorker);
  yield takeLatest(updateUserProfileStart.type, updateUserProfileWorker);
}

function* userProfileWorker(action) {
  try {
    const { data, error } = yield userProfileService.getUserProfile();
    if (action.payload?.walletLoading) {
      yield put(getWalletBalanceSuccess(data?.Wallet?.amount));
    }
    if (!action.payload?.walletLoading && data?.metamaskAddress) {
      yield put(
        connectMetamaskSuccess({
          walletAddress: data?.metamaskAddress,
        })
      );
    }
    if (!error) {
      yield put(getUserProfileDetailsSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error.message }));
      yield put(getUserProfileDetailsFailure(error));
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
    yield put(
      getUserProfileDetailsFailure({
        walletLoading: action.payload?.walletLoading || null,
      })
    );
  }
}

function* updateUserProfileWorker(action) {
  try {
    const { data, error } = yield userProfileService.updateUserProfile(
      action.payload
    );
    if (!error) {
      yield put(
        showSuccessMessage({ tKey: "MYPROFILE.USER_DETAIL_UPDATE_SUCCESS" })
      );
      yield put(updateUserProfileSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error.message }));
      yield put(updateUserProfileFailure());
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
    yield put(updateUserProfileFailure());
  }
}

export default userProfileWatcher;
